import React from 'react'

import Homebanner from "../images/MAIN Banner.jpg";

import carrelocationservice from "../images/CAR Relocation photo.jpg";
import atmshifting from "../images/ATM Machine Shifting.jpg";

import carrelocation from "../images/CAR Relocation img.jpg";
import homeshifting from "../images/HOME SHIFTING new.jpg";

import "./Slider.css";

function Slider() {
  return (
    <div>

<div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
     
      <div className='radiusslider'>
      <img src={Homebanner} className="d-block w-100" alt="packersmovers"/>
      </div>
  
    </div>
    <div className="carousel-item"> 
    <div className='radiusslider'>
      <img src={homeshifting} className="d-block w-100" alt="homeshifting"/>    
      </div>
    </div>
    <div className="carousel-item"> 
    <div className='radiusslider'>
      <img src={carrelocation} className="d-block w-100" alt="carrelocationservice in India"/>    
      </div>
    </div>
    <div className="carousel-item"> 
    <div className='radiusslider'>
      <img src={atmshifting} className="d-block w-100" alt="Best Packers Movers in New Town"/>    
      </div>
    </div>
    <div className="carousel-item"> 
    <div className='radiusslider'>
      <img src={carrelocationservice} className="d-block w-100" alt="carrelocationservice"/>    
      </div>
    </div>
    

    
    
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider